const BrowserSupport = {
	init: function () {
		const toHide = document.querySelectorAll('#map-div, .map-menu');
		toHide.forEach((el) => {
			el.remove();
		});
		const div = document.createElement('div');
		div.classList.add('no-webgl2-support');
		const p = document.createElement('p');
		p.innerHTML =
			"The University of Wisconsin\u2013Madison campus map requires a browser that supports Web GL2. <a href='https://caniuse.com/webgl'>Most modern web browsers</a> support it and enable it by default. Please make sure it is enabled or try upgrading your browser. Return to the <a href='https://www.wisc.edu'>university home page</a>.";
		div.append(p);
		document.querySelector('body').append(div);

		if (typeof gtag !== 'undefined') {
			gtag('event', 'no_webgl2');
		}
	},
};

export default BrowserSupport;
